"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateIsAssembly = void 0;
const common_1 = require("../../common");
class UpdateIsAssembly extends common_1.UpdateAction {
}
exports.UpdateIsAssembly = UpdateIsAssembly;
//# sourceMappingURL=update-is-assembly.action.js.map